import { Validators } from '@angular/forms';
import {
  commonRegex,
} from 'remarketing-angular-library';

export const PHONE_VALIDATORS = [
  Validators.minLength(10),
  Validators.maxLength(10),
  Validators.pattern(commonRegex.noLeadingZeroOrOneMobileNumberValidator.source)
];
